import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import TemplateEditorIsland from "react-app/islands/TemplateEditorIsland"

interface Signature {
  Args: {
    cardStack: CardStack
    className?: string
    onDelete?: () => void
  }
}

export default class TemplateEditorIslandBridge extends Component<Signature> {
  readonly TemplateEditorIsland = TemplateEditorIsland
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Bridges::TemplateEditorIslandBridge": typeof TemplateEditorIslandBridge
  }
}
